// src/components/Assessment/QuizCreator.jsx
import React, { useState } from "react";
import styles from "./Assessment.module.css";
import { Controller, useForm } from "react-hook-form";
import { hooks } from "../../studentportal-sdk";
/* eslint-disable */


const AssessmentCreator = (props) => {

  const [formData,setFormData] = useState({
    "Id": localStorage.getItem('assessmentId'),
    "courseId": "",
    "title": "",
    "description": "",
    "timer": "",
    "startDate": "",
    "endDate": ""
  })

  //   const addQuestion = () => {
  //     if (
  //       currentQuestion.trim() === "" ||
  //       options.some((opt) => opt.trim() === "")
  //     ) {
  //       alert("Please fill in all fields for the question.");
  //       return;
  //     }

  //     const newQuestion = {
  //       question: currentQuestion,
  //       options: [...options],
  //       correctOption,
  //     };

  //     setQuestions([...questions, newQuestion]);
  //     setCurrentQuestion("");
  //     setOptions(["", "", "", ""]);
  //     setCorrectOption(0);
  //   };

  //   const createQuiz = () => {
  //     if (quizTitle.trim() === "" || questions.length === 0) {
  //       alert("Please provide a quiz title and add at least one question.");
  //       return;
  //     }

  //     const newQuiz = {
  //       title: quizTitle,
  //       description: quizDescription,
  //       questions,
  //     };

  //     addQuiz(newQuiz);
  //     setQuizTitle("");
  //     setQuizDescription("");
  //     setQuestions([]);
  //   };

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {},
  });

  const {
    courseService: {
      store: { courseDocs },
    },
    assessmentService:{
        store:{loading},
        action:{updateAssessment}
    }
  } = props;

  const onSubmit = (data) => {
    if(data) {
        setFormData({...formData,...data})
        updateAssessment(formData)
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h2>Update Assessment</h2>
      <div className={styles.formGroup}>
        <label>Assessment Title:</label>
        <Controller
          name="title"
          control={control}
          render={({ field: { value, onChange } }) => (
            <input
              type="title"
              className={`form-control ${errors?.title ? "error-input" : ""}`}
              value={value}
              onChange={onChange}
            />
          )}
          defaultValue={''}
        />
        <small className="text-danger">{errors?.title?.message}</small>
      </div>
      <div className={styles.formGroup}>
        <label>Assessment Description:</label>
        <Controller
          name="description"
          control={control}
          render={({ field: { value, onChange } }) => (
            <textarea
              className={`form-control ${
                errors?.description ? "error-input" : ""
              }`}
              value={value}
              onChange={onChange}
            />
          )}
          defaultValue=""
        />
        <small className="text-danger">{errors?.description?.message}</small>
      </div>
      <div className={styles.formGroup}>
        <label>Select Course:</label>
        <Controller
          name="courseId"
          control={control}
          render={({ field: { value, onChange } }) => (
            <>
              <select
                className={`form-control ${
                  errors?.courseId ? "error-input" : ""
                }`}
                name="courseId"
                type="text"
                  value={value}
                onChange={onChange}
              >
                <option className="form-control" value="">
                  Select Category
                </option>
                {courseDocs &&
                  courseDocs.map((course) => (
                    <option className="form-control" value={course.id}>
                      {course.title}
                    </option>
                  ))}
              </select>
            </>
          )}
          defaultValue=""
        />
        <small className="text-danger">{errors?.courseId?.message}</small>
      </div>
      <div className="row">
        <div className="col-md-4">
          <div className="form-group">
            <label>Timer</label>
            <Controller
              name="timer"
              control={control}
              render={({ field: { value, onChange } }) => (
                <input
                  type="time"
                  className={`form-control ${
                    errors?.time ? "error-input" : ""
                  }`}
                  value={value}
                  onChange={onChange}
                />
              )}
              defaultValue=""
            />
            <small className="text-danger">{errors?.time?.message}</small>
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <label>Start Date</label>
            <Controller
              name="startDate"
              control={control}
              render={({ field: { value, onChange } }) => (
                <input
                  type="date"
                  className={`form-control ${
                    errors?.startDate ? "error-input" : ""
                  }`}
                  value={value}
                  onChange={onChange}
                />
              )}
              defaultValue=""
            />
            <small className="text-danger">{errors?.startDate?.message}</small>
          </div>
        </div>
        {/* End Date */}
        <div className="col-md-4">
          <div className="form-group">
            <label>End Date</label>
            <Controller
              name="endDate"
              control={control}
              render={({ field: { value, onChange } }) => (
                <input
                  type="date"
                  className={`form-control ${
                    errors?.endDate ? "error-input" : ""
                  }`}
                  value={value}
                  onChange={onChange}
                />
              )}
              defaultValue=""
            />
            <small className="text-danger">{errors?.endDate?.message}</small>
          </div>
        </div>
      </div>


      <button className={styles.submitButton} disabled={loading.active}>{loading.active?"Creating...":"Update Assessment"}</button>
    </form>
  );
};

export default (props) => <AssessmentCreator {...hooks.assessment(props)} />;
